import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import TextField from '../../TextField';

const NumberField = forwardRef((props, ref) => {
    const { min, max, InputProps, ...otherProps } = props;

    return (
        <TextField
            {...otherProps}
            ref={ref}
            type="number"
            InputProps={{
                min,
                max,
                ...InputProps
            }}
            onWheel={ev => {
                ev.target.blur();
            }}
        />
    );
});

NumberField.displayName = 'NeptuneNumberField';

NumberField.propTypes = {
    min: PropTypes.number,
    max: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    InputProps: PropTypes.any
};

NumberField.defaultProps = {
    min: null,
    max: null,
    InputProps: null
};

export default NumberField;
